import { useState, useEffect } from 'react';

export interface CalendarEvent {
  id: string;
  title: string;
  date: string;
  imageUrl?: string;
  isPast: boolean;
}

export function useCalendarEvents() {
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/calendar')
      .then((res) => {
        if (!res.ok) {
          throw new Error('API request failed');
        }
        return res.json();
      })
      .then((data: CalendarEvent[]) => setEvents(data))
      .catch(() => setError('Kunne ikke laste events'))
      .finally(() => setLoading(false));
  }, []);

  return { events, loading, error };
}
